var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNegative(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6155 7.01318L8.79276 7.01318L8.79276 1.52182L10.6155 1.52182C10.7175 1.52182 10.8153 1.56761 10.8874 1.64928C10.9595 1.73085 11 1.84156 11 1.95691L11 6.57805C11 6.69345 10.9595 6.80413 10.8874 6.88574C10.8153 6.96733 10.7174 7.01318 10.6155 7.01318Z",
    stroke: "#A9A9AE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.79272 7.01355L6.83929 10.5468C6.76358 10.6865 6.6572 10.8016 6.53051 10.8809C6.40382 10.9602 6.26113 11.001 6.11636 10.9994C6.00233 11.004 5.88864 10.9828 5.78201 10.9369C5.67536 10.8909 5.57794 10.8213 5.49549 10.7321C5.41304 10.6428 5.34723 10.5358 5.30197 10.4173C5.2567 10.2988 5.23288 10.1712 5.23193 10.0421L5.23193 7.50961L1.85569 7.50961C1.73096 7.50503 1.60848 7.47062 1.49631 7.40864C1.38414 7.34667 1.28484 7.25854 1.20491 7.15003C1.12499 7.04152 1.06631 6.91511 1.03267 6.77909C0.999023 6.64307 0.991193 6.50053 1.00972 6.36086L1.62499 1.87028C1.6512 1.63028 1.75406 1.4094 1.91406 1.24914C2.07406 1.08887 2.28034 1.00028 2.49406 1.00001L7.53914 1.00001C7.77931 0.998961 8.01635 1.0615 8.23131 1.18282L8.78504 1.49607",
    stroke: "#A9A9AE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.79272 7.01367L8.79273 1.52227",
    stroke: "#A9A9AE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNegative);
export default __webpack_public_path__ + "static/media/negative.3b365163fb35c7f39303fe23f890b5eb.svg";
export { ForwardRef as ReactComponent };